import { render } from "./AccordionTabs.vue?vue&type=template&id=7df837a0"
import script from "./AccordionTabs.vue?vue&type=script&lang=js"
export * from "./AccordionTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__